import React from "react";
import { FaGift, FaClock, FaStar, FaArrowRight } from "react-icons/fa";
import "../styles/PromotionalBanner/PromotionalBanner.css";
export default function PromotionalBanner() {
  return (
    <section className="promo-section">
      <div className="container">
        {/* Main Banner */}
        <div className="promo-banner">
          <div className="bg-pattern"></div>
          <div className="circle top-right"></div>
          <div className="circle bottom-left"></div>

          <div className="promo-content">
            <div className="promo-text">
              <div className="badge">
                <FaGift /> Limited Time Offer
              </div>
              <h2>
                Get 40% OFF <br />
                <span>First Booking</span>
              </h2>
              <p>
                New customer? Enjoy massive savings on your first home service booking. All
                categories included!
              </p>

              <div className="button-group">
                <button className="btn btn-primary">
                  Claim Offer Now <FaArrowRight />
                </button>
                <button className="btn btn-outline">Browse Services</button>
              </div>

              <div className="promo-footer">
                <span>
                  <FaClock /> Valid till Dec 31, 2024
                </span>
                <span>
                  <FaStar /> No minimum order
                </span>
              </div>
            </div>

            <div className="price-card">
              <div className="price-details">
                <div className="price-row">
                  <span>Original Price</span>
                  <span className="line-through">₹1,000</span>
                </div>
                <div className="price-row">
                  <span>First Time Discount</span>
                  <span className="discount">-40%</span>
                </div>
                <div className="price-total">
                  <span>You Pay</span>
                  <span className="final-price">₹600</span>
                  <div className="save-text">You Save ₹400!</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Secondary Offers */}
        <div className="offers">
          <div className="offer-card green">
            <div className="icon-circle">
              <FaGift />
            </div>
            <h3>Refer & Earn</h3>
            <p>Refer friends and earn ₹200 for each successful booking. No limit!</p>
            <button className="btn btn-sm green-btn">Start Referring</button>
          </div>

          <div className="offer-card blue">
            <div className="icon-circle">
              <FaStar />
            </div>
            <h3>Loyalty Program</h3>
            <p>Book 5 services and get the 6th one absolutely free. Start collecting points!</p>
            <button className="btn btn-sm blue-btn">Join Now</button>
          </div>

          <div className="offer-card purple">
            <div className="icon-circle">
              <FaClock />
            </div>
            <h3>Weekend Special</h3>
            <p>Book weekend services and get 20% off. Perfect for busy weekdays!</p>
            <button className="btn btn-sm purple-btn">Book Weekend</button>
          </div>
        </div>

        <div className="terms">
          *Terms and conditions apply. Offer valid for new customers only. Cannot be combined
          with other offers. Maximum discount ₹500.
        </div>
      </div>
    </section>
  );
}
